import { Button } from '@/components/Elements/Button/Button';
import { Box, Grid } from '@mui/material';
import awsconfig from '@/amplifyconfiguration.json';
import { Amplify } from 'aws-amplify';
import { useNavigate } from 'react-router';
import { useCognitoAuth } from '@/hooks/useCognitoAuth';
import { PageName } from '.';
import { Hub } from 'aws-amplify/utils';
import { useLocation } from 'react-router';
import { useEffect } from 'react';

const pathOrigin = window.location.origin;

// MEMO: 本来使用されない画面
export const LoginForm = (props: { setActivePage: React.Dispatch<React.SetStateAction<PageName>> }) => {
  const location = useLocation();
  awsconfig.oauth.redirectSignIn = pathOrigin + location.pathname;
  awsconfig.oauth.redirectSignOut = pathOrigin + location.pathname;
  console.log('awsconfig.oauth.redirectSignIn', awsconfig.oauth.redirectSignIn);
  Amplify.configure(awsconfig);
  const navigate = useNavigate();
  const { handleSignOut } = useCognitoAuth();

  useEffect(() => {
    Hub.listen('auth', (data) => {
      try {
        switch (data.payload.event) {
          case 'signedIn':
          case 'signInWithRedirect':
            break;
          case 'signInWithRedirect_failure':
            console.log('Sign in failure');
            break;
          default:
            break;
        }
      } catch (error) {}
    });
  }, []);

  const logout = async () => {
    await handleSignOut();
    navigate('/');
  };

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} justifyContent={'center'} spacing={2}>
          <Grid item xs={12} sm={8}>
            <Button variant="main" size="lg" className="w-full" onClick={() => logout()}>
              <div>ログアウト</div>
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
